import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

export const fetchForms = async (mode = "visible") => {
  const tenantId = getTenantIdFromHost();
  const formsSnapshot = await getDocs(collection(db, "tenants", tenantId, "forms"));

  const allForms = formsSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const isHidden = (form) => form?.hidden === true;

  switch (mode) {
    case "hidden":
      return allForms.filter(isHidden);

    case "all":
      return allForms;

    case "visible":
    default:
      return allForms.filter((f) => !isHidden(f));
  }
};
